import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import Select from './Select'

const _createOptions = (length) => {
  let options = Array.from({ length: length }, (_, i) => {
    return {value: `${i + 1}`, label: `${i + 1} Adults`}
  })
  options[0].label = "1 Adult"
  return options
}

const escapeRegexCharacters = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const filterOptions = (candidate, input) => {
  const escapedValue = escapeRegexCharacters(input.trim())
  const regex = new RegExp('\\b' + escapedValue, 'i')
  if (input) {
    return regex.test(candidate.value)
  }
  return true
}

const SearchAdults = ({
  setAdults,
  error = false,
  controlledValue = null,
  optionsLength = 10,
  disabled = false
}) => {
  const [options, setOptions] = useState(_createOptions(optionsLength))
  const [value, setValue]     = useState(options[0])

  useEffect(() => {
    if(controlledValue) {
      setValue(options[controlledValue - 1])
    }
  }, [controlledValue])

  useEffect(() => {
    if(optionsLength) {
      setOptions(_createOptions(optionsLength))
    }
  }, [optionsLength])

  const _handleChange = (selected, action) => {
    let value = action.action == "clear" ? '' : selected
    setAdults(parseInt(value.value))
    setValue(value)
  }

  return (
    <label className={`adults ${error ? 'error' : ''}`} title="Number of Adults" htmlFor="adults">
      <div className="fields-icon-wrapper">
        <i className="fas fa-user-alt main-icon" />
        <Select
          name          = "adults"
          value         = {value}
          options       = {options}
          defaultValue  = {options[1]}
          filterOption  = {filterOptions}
          handleChange  = {_handleChange}
          isDisabled    = {disabled}
        />
      </div>
      { error && <span className="error-text">Max 10 adults per room</span> }
    </label>
  )

}

SearchAdults.propTypes = {
  setAdults: PropTypes.func.isRequired,
  error: PropTypes.bool,
  controlledValue: PropTypes.number,
  optionsLength: PropTypes.number,
  disabled: PropTypes.bool
}

export default SearchAdults
